module.exports = __webpack_public_path__ + "static/marcomazzoli-f0eca46e565f358da014347c6aed7b79.png";